import apiCall from "../utils/apiCall";
import { CandidateResponse, ElectablePositionResponse, GetBranchesResponse, GetChairmanByIdResponse, GetChaptersResponse, OutstandingPaymentPayload, RequestEndorsementPayload } from "../type";


export const getMemberPersonalDetailCall = async (membershipNo: string) => {
  const encodedMembershipNo = encodeURIComponent(membershipNo);
  return (await apiCall().get(`/Member/getpersonaldetail?membershipNo=${encodedMembershipNo}`))?.data
}

export const handleLogOut = () => {
    // resetUser();
    // resetUserDetails()
    localStorage.removeItem("e-voting-member-user");
    localStorage.removeItem("e-voting-member-token");
    localStorage.removeItem('e-voting-profile-details')
    window.location.href ='/';
  }

  export const getElectionNameCall = async () => {
    return (await apiCall().get(`/SetUpVote/GetAllAnnualElectionSetUp`))?.data;
  };
  
  export const getAllElectablePosition =
  async (): Promise<ElectablePositionResponse> => {
    return (await apiCall().get("/SetUpVote/GetAllElectablePosition"))?.data;
  };

  const genderData = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];

  export const genderOptions = genderData.map((item, index) => (
    <option value={item?.value} key={index}>
      {item?.label}
    </option>
  ));

  export const getAllCandidate = async (): Promise<CandidateResponse> => {
    return (await apiCall().get("/SetUpVote/GetAllCandidate"))?.data;
  };

  // request endorsement
export const requestEndorsement = async (payload: RequestEndorsementPayload) => {
	return (await apiCall().post('/Member/createendorsementrequest', payload))?.data as Response;
};

// get branches
export const getAllBranches = async () => {
	return (await apiCall().get('/MembershipSetUp/member/GetAllBranch'))?.data as GetBranchesResponse;
};

//get chapters
export const getAllChapters = async () => {
	return (await apiCall().get('/MembershipSetUp/member/GetAllChapter'))?.data as GetChaptersResponse;
};

//get chapters by branch Id
export const getAllChaptersByBranchId = async (branchId : string | number) => {
	return (await apiCall().get(`/MembershipSetUp/member/GetChapterByBranchId?branchId=${branchId}`))?.data as GetChaptersResponse;
};

export const getChairmanById = async (chairmanId: string) => {
	return (await apiCall().get(`/MembershipSetUp/member/GetChairmanById?chairmanId=${chairmanId}`))?.data as GetChairmanByIdResponse;
}
export const getChairmanByBranchId = async (branchId: string | number) => {
	return (await apiCall().get(`/MembershipSetUp/member/GetActiveChairmanByBranchId?branchId=${branchId}`))?.data as GetChairmanByIdResponse;
}


export const getOutstandingPaymentCall = async (data: OutstandingPaymentPayload) => {
  return (
    await apiCall().post(
      `/Payment/GetCurrentDuePayment`, data
    )
  )?.data;
};


//getElectionNameByActiveElectionId
export const getElectionNameById = async (electionId: number | string) => {
  return (
    await apiCall().get(
      `/SetUpVote/GetAnnualElectionSetUpById?Id=${electionId}`
    )
  )?.data;
};

export const getEndorsementByMembershipId = async(membershipNo: string) => {
  const encodedMembershipNo = encodeURIComponent(membershipNo);
  return(await apiCall().get(`/Member/getendorsementrequestmembershipno?membershipNo=${encodedMembershipNo}`))?.data
}

export const getAllElectablePositionByElectionId =
async (electionId: number): Promise<ElectablePositionResponse> => {
  return (await apiCall().get(`/SetUpVote/GetElectablePositionByIdName?ElectionId=${electionId}`))?.data;
};

 export const getNomineeStatusCall = async (membershipNo: string) => {
    const encodedMembershipNo = encodeURIComponent(membershipNo);
    return (await apiCall().get(`/SetUpVote/GetNomiationByNomineeId?NomineeId=${encodedMembershipNo}`))?.data;
  };

export  const getStateById = async (stateId: number | string) => {
    return (await apiCall().get(`/State/member/GetAllStateById?Id=${stateId}`))?.data;
  };

  //Get nominee status by Id
  export const getNomineeStatusById = async (Id: string | number) => {
    return (await apiCall().get(`/SetUpVote/GetNomiationById?Id=${Id}`))?.data;
  };

  export const getAcademicQualificationById = async(membershipId: string) => {
    const encodedMembershipNo = encodeURIComponent(membershipId);
    return (await apiCall().get(`/Member/getacademicbymembershipno?membershipNo=${encodedMembershipNo}&qualificationId=0`))?.data
  }
  
  export const getProfessionalQualificationById = async(membershipId: string) => {
    const encodedMembershipNo = encodeURIComponent(membershipId);
    return (await apiCall().get(`/Member/getProfessionalBodybyMembershipNo?membershipNo=${encodedMembershipNo}`))?.data
  }

  export const logoutIfTokenExpired = (expiryDateString: any) => {
    var currentDate = new Date();
    var expiryDate = new Date(expiryDateString)
    if(currentDate > expiryDate) {
      return true;
    }
    else{
      return false;
    }
  }

  export const getEligibleGuidelineByElectionId = async (electionId: number) => {
    return (await apiCall().get(`/SetUpVote/GetEligibleGuidelineByElectionId?ElectionId=${electionId}`))?.data;
  }
  export const getEachPendingPaymentCall = async (membershipNo: string) => {
    const membershipNoEncoded = encodeURIComponent(membershipNo);
    return (await apiCall().get(`/Payment/GetEachPendingPaymentByMembershipNo?membershipNo=${membershipNoEncoded}`))?.data;
  }


